export default __webpack_public_path__ + "static/media/Starting_Screen_3_2.5655c698.png";